<template>
<div class="tendance-part">
    <Row type="flex" :gutter="2" style="flex-wrap: nowrap;overflow: visible !important;">
        <Col flex="360px" class="left-panel">
        <!-- 查询条件 -->
        <fieldset class="my-fieldset">
            <legend class="my-legend">{{ getTranslation('r120') }}</legend>
            <div class="mode-switch-row">
                <span class="mode-label">
                    <Radio v-model="isRealtime"></Radio>&nbsp;
                    {{ getTranslation('r137') }}
                    <Tooltip placement="top" theme="light" :transfer="true" max-width="300">
                        <Icon type="md-information-circle" color="#5cadff" size="16" class="form-tip" />
                        <div slot="content">
                            <div v-html="getTranslation('r139')"></div>
                        </div>
                    </Tooltip>
                </span>
                <span class="mode-label">
                    <Radio v-model="isHistory"></Radio>{{ getTranslation('r138') }}
                </span>
            </div>
            <div v-show="!isRealtime" class="form-row">
                {{ getTranslation('k222') }}:<DatePicker size="small" transfer type="datetimerange" format="yyyy-MM-dd HH:mm:ss" placement="bottom-end" 
                v-model="historyRange" @on-change="onHistoryRangeOk"  class="form-input"></DatePicker>
            </div>

            
            <div class="form-row">
                <span class="form-label">
                    <Radio v-model="isProgram" @on-change="tendance"></Radio>{{ getTranslation('b006') }}
                    <Tooltip placement="top" theme="light" :transfer="true" max-width="300">
                        <div slot="content">
                            <div v-html="getTranslation('r130')"></div>
                        </div>
                        <Icon type="md-information-circle" color="#5cadff" size="16" class="form-tip" />
                    </Tooltip>
                </span>
                <Input type="text" v-model="program" @on-blur="tendance" size="small" class="form-input offset" />
            </div>
            <div class="form-row">
                <span class="form-label">
                    <Radio v-model="isSpotId" @on-change="tendance"></Radio>{{ getTranslation('k259') }}
                </span>
                <Input type="text" v-model="spotId" @on-blur="tendance" size="small" class="form-input offset" />
            </div>
           

            <div class="form-row">
                <span class="form-label">{{ getTranslation('k099') }}</span>
                <template v-if="isRealtime">
                <Input type="text" v-model="num" @on-blur="tendance" size="small" class="form-input offset" />
                </template>
                <template v-if="isHistory">
                <Input type="text" v-model="historyNum" @on-blur="tendance" size="small" class="form-input offset" />
                </template>
            </div>
            <div class="checkbox-group">
                <div v-for="field in fieldConfigs" :key="field.key" class="checkbox-item">
                    <Checkbox v-model="showFields[field.key]">
                        {{ getTranslation(field.label) }}
                    </Checkbox>
                </div>
            </div>
        </fieldset>

        <!-- 曲线详情 -->
        <div v-if="curveChartData" class="curve-chart-wrap">
            <fieldset class="my-fieldset">
                <legend class="my-legend">{{ getTranslation('i003') }}&nbsp;
                    <Tooltip :content="openState ? getTranslation('l010') : getTranslation('l011')" placement="bottom" theme ="light" :transfer="true">
                    <Button :type="openState ? 'default' : 'primary'" :icon="openState ? 'md-contract' : 'md-expand'"
                        @click="revert()" class="btn-toggle" size="small" />
                    </Tooltip>
                    </legend>
                <div v-if="openState">
                <div v-for="item in detailFields" :key="item.key" :class="{ 'info-row': true, 'table-row-odd': item.odd }" >
                    <span class="info-label">{{ getTranslation(item.label) }}</span>
                    <span class="info-value" :class="{ 'highlight': item.highlight }">{{ selectRecord ? (selectRecord[item.key] !== undefined ? selectRecord[item.key] : '-') : '-' }}</span>
                </div>
                </div>
            </fieldset>
            <div class="curve-chart-header">
                <span class="cart-title">{{ getTranslation('r136') }}</span>

            </div>
            <div ref="curveChart" class="curve-chart"></div>
        </div>
        </Col>
        <Col flex="auto" ref="rightPanel">
        <fieldset class="my-fieldset">
            <legend class="my-legend">{{ getTranslation('r121') }}</legend>
            <div v-if="isLoading" class="flex-middle">
                <LoadingBar :height="'300px'"/>
            </div>
            <div v-for="field in fieldConfigs" :key="field.key" class="main-chart" v-show="showFields[field.key] && !isLoading">
                <fieldset class="my-fieldset">
                    <legend class="my-legend">{{ getTranslation(field.label) }}</legend>
                    <Row type="flex" style="flex-wrap: nowrap;overflow: visible !important;">
                        <Col flex="1">
                        <div class="one-chart" :ref="'chart' + field.key"></div>
                        </Col>
                    </Row>
                </fieldset>
            </div>
        </fieldset>
        </Col>
    </Row>
</div>
</template>

<script>
import {
    API_URL
} from '@/constants/const.js'
import axios from 'axios';
import {
    mapGetters
} from 'vuex'
import {
    postJsError,
    isNonNegativeInteger,
    formatUTCDateTime
} from '@/util/util.js'
import * as echarts from 'echarts';
import LoadingBar from '@/components/LoadingBar.vue';

const CURVE_KINDS = [{
        key: '0',
        label: '电流'
    },
    {
        key: '1',
        label: '压力'
    },
    {
        key: '2',
        label: '电阻'
    },
    {
        key: '3',
        label: '电压'
    },
];
const now = new Date()
const oneDayAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000)
export default {
    name: 'TendancesGraph',
    components: {        
        LoadingBar,        
    },
    props: {
        selectTab: {
            type: String,
            default: 'm1'
        },
    },
    data() {
        return {
            mac: null,
            timeInterval: 1000,
            showErrorTag: true,
            program: '0',
            spotId: '0',
            num: '10',
            numLimit: 1000,
            historyNum:'10',
            historyLimit:10000,
            timer: null,
            records: [],
            fieldConfigs: [{
                    key: 'CrrPreWeld',
                    label: 'r127'
                },
                {
                    key: 'CrrWeld1',
                    label: 'r122'
                },
                {
                    key: 'CrrWeld2',
                    label: 'r123'
                },
                {
                    key: 'CrrWeld3',
                    label: 'r124'
                },
                {
                    key: 'CrrPostWeld',
                    label: 'r128'
                },
                {
                    key: 'ValPowerCnt',
                    label: 'k231'
                },
                {
                    key: 'ValDutyOnTime',
                    label: 'k232'
                },
                {
                    key: 'ValSecVolt',
                    label: 'k233'
                },
                {
                    key: 'ValSecRest',
                    label: 'k234'
                },
                {
                    key: 'DispRsv10',
                    label: 'r129'
                },
            ],
            showFields: {},
            charts: {},
            chartObservers: {},
            curveChartData: null,
            selectRecord: null,
            curveChart: null,
            curveChartObserver: null,
            isRealtime: true,
            historyRange: [oneDayAgo, now],
            pendingCurves: {},
            pendingWelds: {},
            detailFields: [{
                    key: 'created_string',
                    label: 'k222',
                    odd: true
                },
                {
                    key: 'NoWeldProgram',
                    label: 'b006',
                },
                {
                    key: 'SpotIdString',
                    label: 'k259',
                    odd: true
                },
                {
                    key: 'CrrPreWeld',
                    label: 'r127'
                },
                {
                    key: 'CrrWeld1',
                    label: 'r122',
                    odd: true
                },
                {
                    key: 'CrrWeld2',
                    label: 'r123',
                },
                {
                    key: 'CrrWeld3',
                    label: 'r124',
                    odd: true
                },
                {
                    key: 'CrrPostWeld',
                    label: 'r128'
                },
                {
                    key: 'ValPowerCnt',
                    label: 'k231',
                    odd: true
                },
                {
                    key: 'ValDutyOnTime',
                    label: 'k232'
                },
                {
                    key: 'ValSecVolt',
                    label: 'k233',
                    odd: true
                },
                {
                    key: 'ValSecRest',
                    label: 'k234'
                },
                {
                    key: 'DispRsv10',
                    label: 'r129',
                    odd: true
                },
            ],
            isProgram:true,
            isLoading:false,
            openState:1,
            selectedPointIndex: null,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        webSocketUrl() {
            return API_URL['webSocket'] + "?mac=" + (this.$route.query.mac ? this.$route.query.mac :'');
        },
        isHistory: {
            get() {
                return !this.isRealtime
            },
            set(val) {
                this.isRealtime = !val
            }
        },
        isSpotId: {
            get() {
                return !this.isProgram
            },
            set(val) {
                this.isProgram = !val
            }
        },
        
    },
    watch: {
        records: {
            handler: 'drawAllCharts',
            deep: true,
        },
        showFields: {
            handler: 'drawAllCharts',
            deep: true,
        },
        isHistory:{
            handler: 'onModeChange',
        }
    },
    created() {
        this.mac = this.$route.query.mac
        let showList = localStorage.getItem('tendances.show') || 'CrrPreWeld';
        this.program = localStorage.getItem('tendances.program') || '0';
        this.spotId = localStorage.getItem('tendances.spotId') || '';
        this.num = localStorage.getItem('tendances.num') || '50';
        this.historyNum = localStorage.getItem('tendances.historyNum') || '50';
        this.isProgram = localStorage.getItem('tendances.isProgram') === 'true' || localStorage.getItem('tendances.isProgram') === '';
        
        this.fieldConfigs.forEach(f => {
            this.$set(this.showFields, f.key, showList.split(',').includes(f.key));
        });
        this.getData();
    },
    mounted() {},
    methods: {
        async getData() {
            this.tendance();
        },
        async tendance() {
            this.isLoading = true;
            if (this.selectTab != 'm4') {
                this.isLoading = false;
                return;
            }
            if (this.program == '') {
                this.$Message.error(this.getTranslation('r131'));
                this.isLoading = false;
                return;
            }
            let programAry = this.program.split(',').map(s => s.trim()).filter(s => s);
            programAry.forEach(p => {
                if (!isNonNegativeInteger(p)) {
                    this.$Message.error(this.getTranslation('r132'));
                    this.isLoading = false;
                    return;
                }
            })

            if (this.spotId && !isNonNegativeInteger(this.spotId)) {
                this.$Message.error(this.getTranslation('r133'));
                this.isLoading = false;
                return;
            }
            if (this.isRealtime && (!isNonNegativeInteger(this.num) || this.num == '0')) {
                this.$Message.error(this.getTranslation('r134'));
                this.isLoading = false;
                return;
            }
            if (this.isRealtime && this.num > this.numLimit) {
                this.num = this.numLimit
                this.$Message.error(this.getTranslation('r135'));
                this.isLoading = false;
                return
            }
            if (this.isHistory && (!isNonNegativeInteger(this.historyNum) || this.historyNum == '0')) {
                this.$Message.error(this.getTranslation('r134'));
                this.isLoading = false;
                return;
            }
             if (this.isHistory && this.historyNum > this.historyLimit) {
                this.historyNum = this.historyLimit
                this.$Message.error(this.getTranslation('r140'));
                this.isLoading = false;
                return
            }
            localStorage.setItem('tendances.program', this.program);
            localStorage.setItem('tendances.spotId', this.spotId);
            localStorage.setItem('tendances.num', this.num);
            localStorage.setItem('tendances.historyNum', this.historyNum);
            localStorage.setItem('tendances.isProgram', this.isProgram);
            let url = API_URL["recordTendances"];
            let params = {
                mac: this.mac,                
            }
            if (this.isRealtime){
                params.num = this.num
            }else{                 
                params.num = this.historyNum            
            }
            if (this.isProgram){
                params.program = programAry.join(',');
            }
            if(this.isSpotId){
                params.spotId = this.spotId;
            }
            if (!this.isRealtime && this.historyRange.length === 2) {
                params.start = formatUTCDateTime(this.historyRange[0]);
                params.end = formatUTCDateTime(this.historyRange[1]);
            }
            let res = await axios.get(url, {
                params: params,
                timeout: 300000,
            }).catch((err) => {                
                postJsError(err)
                this.showError(this.getTranslation('c001'));
            })
            if (res && res.data && res.data.code == 200) {
                this.isLoading = false;
                let records = (res.data.data.records || []).slice().reverse();
                this.$set(this, 'records', records);
                this.resetError();                
               
            } else if (res && res.data && res.data.msg) {
                this.showError(res.data.msg);
            } else {
                this.showError(this.getTranslation('c001'));
            }
            this.isLoading = false;
        },
        drawAllCharts() {
            this.$nextTick(() => {
                let showArray = [];
                this.fieldConfigs.forEach(field => {
                    if (this.showFields[field.key]) {
                        showArray.push(field.key);
                    }
                    if (this.showFields[field.key] && this.records.length > 0) {
                        this.drawChart(field.key);
                    } else {
                        this.disposeChart(field.key);
                    }
                });
                if (showArray.length > 0) {
                    localStorage.setItem('tendances.show', showArray.join(','));
                } else {
                    localStorage.setItem('tendances.show', '');
                }
            });
        },
        drawChart(key) {
            
            const dom = this.$refs['chart' + key];
            if (!dom || dom.length === 0) return;
            let chart = this.charts[key];

            if (!chart) {
                chart = echarts.init(dom[0]);
                this.charts[key] = chart;
                if (this.chartObservers[key]) {
                    this.chartObservers[key].disconnect();
                }
                const observer = new ResizeObserver(() => {
                    requestAnimationFrame(() => chart.resize());
                });
                observer.observe(dom[0]);
                this.chartObservers[key] = observer;
                chart.on('click', (params) => {
                    if (params.componentType === 'series') {
                        this.onPointClick(params.dataIndex);
                    }
                });
            }
            
            // Validate selected point index
            if (this.selectedPointIndex !== null && this.selectedPointIndex >= this.records.length) {
                this.selectedPointIndex = null;
            }

            const records = this.records;
            const values = records.map(r => r[key]);
            const xData = records.map((_, idx) => idx);
            // Build data with per-point styling — selected point gets yellow
            const data = xData.map((x, i) => {
                if (i === this.selectedPointIndex) {
                    return {
                        value: [x, values[i]],
                        itemStyle: {
                            color: '#ff9900',
                            shadowBlur: 8,
                            shadowColor: 'rgba(255,215,0,0.6)',
                        }
                    };
                }
                return [x, values[i]];
            });
            chart.setOption({
                backgroundColor: '#f8f9fc',
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    borderColor: '#d9d9d9',
                    textStyle: {
                        color: '#515a6e',
                        fontSize: 12
                    },
                    formatter: function (params) {
                        return `${params.value[1]}`;
                    }
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisLabel: {
                        color: '#909399',
                        fontSize: 10
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#e8eaec'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                            color: '#e8eaec',
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        color: '#909399',
                        fontSize: 10
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#e8eaec'
                        }
                    },
                },
                grid: {
                    left: 10,
                    right: 10,
                    top: 10,
                    bottom: 18
                },
                series: [{
                    symbolSize: 7,
                    type: 'scatter',
                    itemStyle: {
                        color: '#1890ff',
                        shadowBlur: 4,
                        shadowColor: 'rgba(24,144,255,0.25)',
                    },
                    data: data,
                }]
            });
        },
      
        onPointClick(dataIndex) {
            // Toggle: click same point to deselect, click another to switch
            if (this.selectedPointIndex === dataIndex) {
                this.selectedPointIndex = null;
            } else {
                this.selectedPointIndex = dataIndex;
            }

            const record = this.records[dataIndex];
            this.selectRecord = record;
            if (!record || !record.CurveList) {
                this.$Message.warning(this.getTranslation('p032'));
                this.curveChartData = []
            } else {
                this.curveChartData = record.CurveList;
            }
            this.$nextTick(() => {
                this.drawCurveChart();
                this.drawAllCharts();
            });
        },
        drawCurveChart() {
            const dom = this.$refs.curveChart;
            if (!dom) return;
            if (this.curveChart) {
                this.curveChart.dispose();
            }
            this.curveChart = echarts.init(dom);
            if (this.curveChartObserver) {
                this.curveChartObserver.disconnect();
            }
            const curveObserver = new ResizeObserver(() => {
                requestAnimationFrame(() => this.curveChart && this.curveChart.resize());
            });
            curveObserver.observe(dom);
            this.curveChartObserver = curveObserver;
            const series = [];
            let maxLen = 0;
            let kindColor = {
                '0': '#e0525e',
                '1': '#1890ff',
                '2': '#36b37e',
                '3': '#e8953b',
            }
            CURVE_KINDS.forEach(kind => {
                const raw = this.curveChartData[kind.key];
                if (!raw) return;
                let arr;
                try {
                    arr = JSON.parse(raw);
                } catch (e) {
                    return;
                }
                if (!Array.isArray(arr) || arr.length === 0) return;
                if (arr.length > maxLen) maxLen = arr.length;
                series.push({
                    color: kindColor[kind.key],
                    name: kind.label,
                    type: 'line',
                    data: arr,
                    smooth: true,
                    symbol: 'none',
                    lineStyle: {
                        width: 1
                    },
                });
            });
            if (series.length === 0) {
                this.$Message.warning(this.getTranslation('p032'));
                this.curveChartData = null;
                this.selectRecord = null;
                return;
            }
            const xData = Array.from({
                length: maxLen
            }, (_, i) => i);
            this.curveChart.setOption({
                backgroundColor: '#f8f9fc',
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(255,255,255,0.95)',
                    borderColor: '#d9d9d9',
                    textStyle: {
                        color: '#515a6e',
                        fontSize: 12
                    },
                },
                legend: {
                    data: series.map(s => s.name),
                    bottom: 0,
                    textStyle: {
                        color: '#606266',
                        fontSize: 11
                    },
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisLabel: {
                        color: '#909399',
                        fontSize: 10
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#e8eaec'
                        }
                    },
                    splitLine: {
                        show: false
                    },
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                            color: '#e8eaec',
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        color: '#909399',
                        fontSize: 10
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#e8eaec'
                        }
                    },
                },
                grid: {
                    left: 50,
                    right: 20,
                    top: 20,
                    bottom: 40
                },
                series: series.map(s => ({
                    ...s,
                    lineStyle: {
                        ...s.lineStyle,
                        width: 1.5,
                        shadowBlur: 3,
                        shadowColor: 'rgba(0,0,0,0.08)',
                    },
                })),
            });
        },
        closeChart(key) {
            this.$set(this.showFields, key, false);
        },
        disposeChart(key) {
            if (this.charts[key]) {
                this.charts[key].dispose();
                delete this.charts[key];
            }
            if (this.chartObservers[key]) {
                this.chartObservers[key].disconnect();
                delete this.chartObservers[key];
            }
        },
        showError(msg) {
            if (this.showErrorTag) {
                this.$Message.error(msg);
            }

            this.showErrorTag = false;
        },
        resetError() {
            this.showErrorTag = true;
        },
        receiveMessage(obj) {
            if (!obj || !obj.kind) return;
            switch (obj.kind) {
                case 'curve':
                    this.handleCurveMsg(obj.data);
                    break;
                case 'weld':
                    this.handleWeldMsg(obj.data);
                    break;
            }
        },
        buildCurveList(curves) {
            const list = {};
            if (curves.current) list['0'] = JSON.stringify(curves.current);
            if (curves.press) list['1'] = JSON.stringify(curves.press);
            if (curves.resistance) list['2'] = JSON.stringify(curves.resistance);
            if (curves.voltage) list['3'] = JSON.stringify(curves.voltage);
            return list;
        },
        handleWeldMsg(data) {
            const recordId = data.RecordId;
            if (!recordId) return;
            if (this.pendingCurves[recordId]) {
                // curve 先到了，组装完整 record
                const curves = this.pendingCurves[recordId];
                delete this.pendingCurves[recordId];
                data.CurveList = this.buildCurveList(curves);
                this.addRealtimeRecord(data);
            } else {
                // curve 还没到，缓存 weld
                this.pendingWelds[recordId] = data;
            }
        },
        handleCurveMsg(data) {
            const recId = data.recId;
            if (!recId) return;
            if (this.pendingWelds[recId]) {
                // weld 先到了，组装完整 record
                const weld = this.pendingWelds[recId];
                delete this.pendingWelds[recId];
                weld.CurveList = this.buildCurveList(data.curves);
                this.addRealtimeRecord(weld);
            } else {
                // weld 还没到，缓存 curve
                this.pendingCurves[recId] = data.curves;
            }
        },
        onModeChange(val) {
            this.selectedPointIndex =-1;
            if (!val) {
                // 切换到历史模式，清空实时缓存
                this.pendingCurves = {};
                this.pendingWelds = {};
                this.tendance();
            } else {
                // 切换回实时模式，重置时间范围，重新加载
                this.tendance();
            }
        },
        onHistoryRangeOk() {
            this.tendance();
        },
        addRealtimeRecord(record) {
            if (!this.isRealtime) return;
            if (!record) return;
            if (this.isSpotId && this.spotId !== '' && record.SpotIdString != this.spotId) {
                return;
            }
            const programList = this.program ? this.program.split(',') : [];
            if (this.isProgram && programList.indexOf(String(record.NoWeldProgram)) === -1) {
                return;
            }
            this.records.push(record);
            this.selectedPointIndex -=1;
            const maxLen = parseInt(this.num) || 10;
            if (this.records.length > maxLen) {
                this.records = this.records.slice(this.records.length - maxLen);
            }
        },
        revert(){
            this.openState = !this.openState;
        }

    },
    beforeDestroy() {
        Object.keys(this.charts).forEach(key => {
            this.charts[key].dispose();
        });
        Object.values(this.chartObservers).forEach(obs => obs.disconnect());
        if (this.curveChart) {
            this.curveChart.dispose();
        }
        if (this.curveChartObserver) {
            this.curveChartObserver.disconnect();
        }
    }

}
</script>

<style scoped>
@import url("../../../assets/style/tab.css");

.tendance-part {
    margin-left: 8px !important;
    background: #f5f6f8;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #e8eaec;
    color: #515a6e;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

/* ===== Left Panel ===== */
.left-panel {
    font-size: 13px;
}

/* ----- Mode Switch ----- */
.mode-switch-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8eaec;
}

.mode-label {
    font-size: 12px;
    color: #606266;
    min-width: 28px;
    font-weight: 600;
}

::v-deep(.mode-switch-row .ivu-switch) {
    border: 1px solid #d9d9d9;
    background: #e8eaec;
}

::v-deep(.mode-switch-row .ivu-switch-checked) {
    border-color: #1890ff;
    background: #1890ff;
}

::v-deep(.mode-switch-row .ivu-switch-inner) {
    color: #909399;
    font-size: 11px;
}

/* iView DatePicker light override */
::v-deep(.ivu-date-picker .ivu-input) {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    color: #515a6e;
}

::v-deep(.ivu-date-picker .ivu-input:focus) {
    border-color: #1890ff;
    box-shadow: 0 0 4px rgba(24, 144, 255, 0.2);
}

/* ----- Form Rows ----- */
.form-row {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    gap: 4px;
}

.form-label {
    width: 100px;
    flex-shrink: 0;
    text-align: left;
    color: #515a6e;
    font-weight: 500;
    font-size: 12px;
}

.form-tip {
    flex-shrink: 0;
    cursor: help;
}

.form-input {
    flex: 1;
    min-width: 0;
}

.form-input.offset {
    margin-left: 20px;
}

/* iView Input light override */
::v-deep(.form-input .ivu-input) {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    color: #515a6e;
    border-radius: 2px;
}

::v-deep(.form-input .ivu-input:focus) {
    border-color: #1890ff;
    box-shadow: 0 0 4px rgba(24, 144, 255, 0.2);
}

/* ----- Checkboxes ----- */
.checkbox-group {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e8eaec;
}

.checkbox-item {
    margin-bottom: 1px;
    color: #515a6e;
    font-size: 12px;
}

::v-deep(.checkbox-item .ivu-checkbox-wrapper) {
    color: #515a6e;
}

::v-deep(.checkbox-item .ivu-checkbox-inner) {
    background: #ffffff;
    border-color: #d9d9d9;
}

::v-deep(.checkbox-item .ivu-checkbox-checked .ivu-checkbox-inner) {
    background: #1890ff;
    border-color: #1890ff;
}

/* ----- Detail Info Rows ----- */
.info-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 3px 6px;
    border-bottom: 1px solid #f0f0f0;
    background: #ffffff;
    transition: background 0.15s;
}

.info-row:last-child {
    border-bottom: none;
}

.info-row.table-row-odd {
    background: #f8f8f8;
    border-left: 2px solid #1890ff;
    padding-left: 4px;
}

.info-row.table-row-odd .info-label {
    color: #303133;
}

.info-row.table-row-odd .info-value {
    color: #303133;
}

.info-label {
    flex-shrink: 0;
    width: 120px;
    text-align: left;
    color: #606266;
    font-size: 11px;
}

.info-value {
    flex: 1;
    text-align: right;
    color: #515a6e;
    font-variant-numeric: tabular-nums;
    font-size: 12px;
}

.info-value.highlight {
    color: #1890ff;
    font-weight: 600;
    font-size: 13px;
}

/* ----- Curve Chart Header ----- */
.curve-chart-header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
}

.chart-close-btn {
    position: absolute;
    right: -4px;
    top: -8px;
    z-index: 100;
    width: 22px;
    height: 22px;
    padding: 0;
    border-radius: 50%;
    background: #ff4d5a;
    border: 1px solid rgba(255, 77, 90, 0.35);
    color: #fff;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.chart-close-btn:hover {
    border-color: #ff4d5a;
    transform: scale(1.1);
}

/* ----- Charts (right panel) ----- */
.main-chart {
    width: 100%;
    position: relative;
    margin-bottom: 6px;
    background: #ffffff;
    border: 1px solid #e8eaec;
    border-radius: 3px;
    padding: 4px 2px;
}

.one-chart {
    width: 100%;
    height: 150px;
}

.cart-title {
    display: flex;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    color: #909399;
    letter-spacing: 1px;
}

.cart-title-vertical {
    font-size: 10px;
    color: #959db0;
    letter-spacing: 2px;
    white-space: nowrap;
    transform: rotate(90deg);
    transform-origin: center center;
}

/* ----- Curve Chart ----- */
.curve-chart-wrap {
    margin-top: 10px;
    position: relative;
}

.curve-chart {
    width: 100%;
    height: 280px;
}
</style>
